
var trainingShortInfoWindowActive = 0;


function UpdateTrainingDetails(trainingInfo, i) {
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

    if (width >= 1200) {
        document.getElementById("don-training-overview__TrainingDetail-TimeSlot").innerText = trainingInfo.TimeSlot;
        document.getElementById("don-training-overview__TrainingDetail-Title").innerText = trainingInfo.Title;
        document.getElementById("don-training-overview__TrainingDetail-Button").href = trainingInfo.ButtonLink;
        document.getElementById("don-training-overview__TrainingDetail-Rating").innerText = trainingInfo.Rating;

        var divs = document.querySelectorAll('.don-training-overview__trainingShortInfoWindow');
        var availabilityElement = divs[i].querySelector('.don-training-overview__ExpandedInfoWindow-Row span:nth-child(2)');
        var availabilityClassElement = divs[i].querySelector('.don-training-overview__ExpandedInfoWindow-Row span:nth-child(1)');

        document.getElementById("don-training-overview__TrainingFacts-Availability").innerText = availabilityElement.textContent;
        document.getElementById("don-training-overview__TrainingFacts-AvailabilityClass").className = availabilityClassElement.classList;

        if (document.getElementById("don-training-overview__TrainingDetail-Content") != null) {
            document.getElementById("don-training-overview__TrainingDetail-Content").innerHTML = trainingInfo.Topics;
            if (trainingInfo.ImageUrl[0] == "~") {
                trainingInfo.ImageUrl = trainingInfo.ImageUrl.slice(1);
            }
            document.getElementById("don-training-overview__TrainingDetail-Image").src = trainingInfo.ImageUrl;
        }
        if (document.getElementById("don-training-overview__TrainingFacts-Topics") != null) {
            document.getElementById("don-training-overview__TrainingFacts-Topics").innerHTML = trainingInfo.Topics;
            document.getElementById("don-training-overview__TrainingFacts-AccurateLocation").innerText = trainingInfo.TownLocation;
            document.getElementById("don-training-overview__TrainingFacts-Speakers").innerText = trainingInfo.Speakers;
        }
    }
    else {
        document.getElementById("don-ExpandedInfoWindow-" + trainingShortInfoWindowActive).style.display = "none";
        document.getElementById("don-ExpandedInfoWindow-" + i).style.display = "block";
    }

    document.getElementById("don-ShortInfoWindow-" + trainingShortInfoWindowActive).classList.remove('don-training-overview__trainingShortInfoWindow-active');
    document.getElementById("don-ShortInfoWindow-" + i).classList.add('don-training-overview__trainingShortInfoWindow-active');
    trainingShortInfoWindowActive = i;
}

function RemoveOpenedUpShortInfoWindow() {
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    if (width < 1200) {
        document.getElementById("don-ExpandedInfoWindow-" + trainingShortInfoWindowActive).style.display = "none";
        document.getElementById("don-ShortInfoWindow-" + trainingShortInfoWindowActive).classList.remove('don-training-overview__trainingShortInfoWindow-active');
        trainingShortInfoWindowActive = 0;
    }
}

function FilterByLocationTrainingDetails(location, trainingListCount) {
    var filterTitle = document.getElementById("typeDropdownMenuButton");

    if (filterTitle != null && filterTitle.innerText.trim() != "Alle Fortbildungen") {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-ShortInfoWindow-TownLocation-" + i).innerText.trim() == location.trim() && document.getElementById("don-ShortInfoWindow-Title-" + i).innerText.trim() == filterTitle.innerText.trim()) {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "";
            }
            else {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "none";
            }
        }
    }
    else {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-ShortInfoWindow-TownLocation-" + i).innerText.trim() == location.trim()) {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "";
            }
            else {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "none";
            }
        }
    }

    document.getElementById("locationDropdownMenuButton").innerText = location;

    RemoveOpenedUpShortInfoWindow();
}

function FilterByTitleTrainingDetails(title, trainingListCount) {
    var filterLocation = document.getElementById("locationDropdownMenuButton").innerText;

    if (filterLocation.trim() != "Alle Orte") {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-ShortInfoWindow-Title-" + i).innerText.trim() == title.trim() && document.getElementById("don-ShortInfoWindow-TownLocation-" + i).innerText.trim() == filterLocation.trim()) {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "";
            }
            else {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "none";
            }
        }
    }
    else {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-ShortInfoWindow-Title-" + i).innerText.trim() == title.trim()) {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "";
            }
            else {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "none";
            }
        }
    }

    document.getElementById("typeDropdownMenuButton").innerText = title;

    RemoveOpenedUpShortInfoWindow();
}

function RemoveFilterTrainingDetails(objectType, trainingListCount) {
    if (objectType == 'location') {
        document.getElementById("locationDropdownMenuButton").innerText = "Alle Orte";

        var filterTitle = document.getElementById("typeDropdownMenuButton");
        if (filterTitle != null && filterTitle.innerText.trim() != "Alle Fortbildungen") {
            FilterByTitleTrainingDetails(filterTitle, trainingListCount);
        }
        else {
            for (var i = 0; i < trainingListCount; i++) {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "";
            }
        }
    }
    else if (objectType == 'type') {
        document.getElementById("typeDropdownMenuButton").innerText = "Alle Fortbildungen";

        var filterLocation = document.getElementById("locationDropdownMenuButton").innerText;
        if (filterLocation != "Alle Orte") {
            FilterByLocationTrainingDetails(filterLocation, trainingListCount);
        }
        else {
            for (var i = 0; i < trainingListCount; i++) {
                document.getElementById("don-ShortInfoWindow-" + i).style.display = "";
            }
        }
    }

    RemoveOpenedUpShortInfoWindow();
}
